import { authLogout } from "../../../store/actions/authActions";
import { clearLayers } from "../../../store/actions/layerActions";
import { clearMessage, setMessage } from "../../../store/actions/dialogActions";
import { setNotifications } from "../../../store/actions/notificationActions";
import API from "../../../store/api";
import { getAllLayers } from "./getAllLayers";

export const createLayer = (userData, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.post(`/api/portal/layers`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send(userData)
      .ok(res => res.status === 201 || res.status === 401)
      .then((response) => {
        if (response.status === 201) {
          dispatch(clearMessage)
          dispatch(getAllLayers(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully created.'
          }))
          formFunction()
        } else if (response.status === 401) {
          dispatch(clearLayers);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Create Layer Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}